import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response?.businessLines
}

const getMccFromBizCategory = (tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getBizProgDetailsFromMccCode,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {},
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data.data)
    })
    .catch((error) => {
      throw error
    })
}

export { getMccFromBizCategory }
